import React, { useEffect, useState } from "react";

export default function UserDeactivateModal({
  show,
  onClose,
  onConfirm,
  itemName,
}) {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (show) {
      setReason("");
    }
  }, [show]);

  return (
    <div
      className={`modal fade ${show ? "show d-block" : ""}`}
      tabIndex="-1"
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }}
      role="dialog"
    >
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Confirm Deactication Action</h5>
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body">
            <p>
              Do you want to deactivate <strong>{itemName || "this item"}</strong>?
            </p>
            <div className="mt-3">
              <label htmlFor="user-deactivate-reason" className="form-label">
                Reason
              </label>
              <textarea
                id="user-deactivate-reason"
                className="form-control"
                rows="4"
                placeholder="Enter reason for deactivating this user"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              ></textarea>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-danger"
              onClick={() => onConfirm(reason)}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
